import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import Index from "./pages/Index";

const EntryDetail = lazy(() => import("./pages/EntryDetail"));
const WhatIsNercCip = lazy(() => import("./pages/WhatIsNercCip"));
const HowToUse = lazy(() => import("./pages/HowToUse"));
const CipStandards = lazy(() => import("./pages/CipStandards"));
const CipStandardDetail = lazy(() => import("./pages/CipStandardDetail"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Suspense fallback={<div className="min-h-screen bg-background" />}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/what-is-nerc-cip" element={<WhatIsNercCip />} />
            <Route path="/how-to-use" element={<HowToUse />} />
            <Route path="/cip-standards" element={<CipStandards />} />
            <Route path="/cip/:cipId" element={<CipStandardDetail />} />
            <Route path="/entry/:id" element={<EntryDetail />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
